import { getTeamsById } from 'conversations/modules/teams/selectors'
import { getAllConversationSections } from 'conversations/modules/user/sections/selectors'
import { getCurrentUserId } from 'conversations/modules/user/selectors'
import { createConditionsArray, evaluateCondition } from 'conversations/utils/conditionsUtil'
import { useSelector } from 'react-redux'
import Conversation from 'shared/typings/conversations/Conversation'
import { ConversationSidebarFilterCondition } from 'shared/typings/conversationsSidebar/Filters'

import { RootState } from 'typesafe-actions'

const emptyArray: Conversation[] = []

export const useConversationFiltering = (
  sectionID: string,
  conversations: Conversation[],
  doFilter = true
): Conversation[] => {
  const currentUserId = useSelector(getCurrentUserId)
  const sectionConfig = useSelector(
    (state: RootState) => getAllConversationSections(state)[sectionID]
  )
  const allTeams = useSelector(getTeamsById)

  if (!doFilter) {
    return conversations
  }

  let filteredConvos: Conversation[] = emptyArray
  const sectionConditions = createConditionsArray(sectionConfig.condition)

  switch (sectionConfig.type) {
    case 'my-convos':
      filteredConvos = conversations.filter(
        (convo: Conversation) => currentUserId && convo.participantIds.includes(currentUserId)
      )
      break
    case 'all-convos':
      filteredConvos = conversations
      break
    case 'no-participants':
      filteredConvos = conversations.filter(
        (convo: Conversation) => convo.participantIds.length === 0
      )
      break
    case 'compound':
    case null:
      filteredConvos = conversations.filter((convo: Conversation) => {
        switch (sectionConfig.condition.operator) {
          case 'or': {
            return (
              sectionConditions?.some((condition: ConversationSidebarFilterCondition) =>
                evaluateCondition(convo, allTeams, condition)
              ) || false
            )
          }
          default: {
            return (
              sectionConditions?.every((condition: ConversationSidebarFilterCondition) =>
                evaluateCondition(convo, allTeams, condition)
              ) || false
            )
          }
        }
      })
      break
  }
  return filteredConvos
}
